import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';

type RefreshComponent = {};

type RefreshComponentContext = {
  feedEntry?: {
    _parentFeedPath?: string;
  };
  entry?: {
    _parentFeedPath?: string;
  };
  uiComponent?: {
    id?: string;
    data?: {
      source?: string;
    };
  };
};

/**
 * Requests a UI component refresh for the current feed entry or component.
 *
 * @param action - Prepared action with `context.uiComponent`, `context.feedEntry`, or `context.entry`.
 * @returns `ActionResult.Success` when dispatched; `ActionResult.Error` on missing context.
 */
export const refreshComponent: ActionHandler<
  RefreshComponent,
  RefreshComponentContext
> = async (action) => {
  if (!action.context) {
    return ActionResult.Error;
  }

  const feedPath =
    action.context.feedEntry?._parentFeedPath ||
    action.context.entry?._parentFeedPath ||
    action.context.uiComponent?.data?.source;

  const componentId = action.context.uiComponent?.id;

  if (!feedPath && !componentId) {
    return ActionResult.Error;
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('action:refreshComponent', {
        detail: {
          feedPath,
          componentId,
        },
      })
    );
  }

  return ActionResult.Success;
};
